import React, { useState } from 'react';
import Modal from '../Modal/Modal';
import ConfirmAndCancel from '../Buttons/ConfirmAndCancel';
import FormDropdown from '../FormField/FormDropdown';
import { cancellationReasons } from '../../Components-Pages/Bookings2/Helper'

function CancelBookingPopupAdmin({
  show,
  onClose,
  // submitResponse,
  onConfirm
}) {
  let [cancelReason, setCancelReason] = useState('');
  //let [showCancelButton, setShowCancelButton] = useState('');

  const cancelReasonOptions = cancellationReasons.map((reason) => {
    return (
      <option value={reason.value} key={reason.value}>
        {reason.description}
      </option>
    );
  });

  const cancelReasonOptionHandler = (e) => {
    /* const allowCancelReason = cancellationReasons.find((reason) => {
      return reason.value == e.target.value;
    }); */
    //setShowCancelButton(allowCancelReason ? allowCancelReason.allowCancel : '');
    setCancelReason(e.target.value);
  };

  return (
    <Modal
      show={show}
      onClose={onClose}
      header='Cancel Booking'
      className='delete-modal'
    >
        <>
          <FormDropdown onChange={cancelReasonOptionHandler}>
            <option value=''>Select a cancellation reason</option>
            {cancelReasonOptions}
          </FormDropdown>

           {/*  {showCancelButton ? ( */}
            <ConfirmAndCancel
              onCancel={onClose}
              cancelText='Go Back'
              onConfirm={() => {
                  console.log("cancelReason " + cancelReason)
                onConfirm(cancelReason);
                onClose();
              }}
              confirmText='Submit'
            />{/* 
          ) : (
            showCancelButton === ''
          ) }*/}
        </>
    </Modal>
  );
}

export default CancelBookingPopupAdmin;
